<template>
   <HeaderDash />
   <SideMenu /> 
   <ContentSubscription /> 
</template>
<script>
// Importando los componententes pertenecientes a esta vista
import HeaderDash from '@/components/team/dashboard/HeaderDash.vue'
import SideMenu from '@/components/team/dashboard/SideMenu.vue'
import ContentSubscription from '@/components/team/dashboard/modules/subscription/ContentSubscription.vue'

export default 
{
  name: 'Subscription',
  components: 
  {
    HeaderDash,
    SideMenu,
    ContentSubscription
  }
}
</script>
<style>


</style>